'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface LoyaltyTier {
  name: string;
  points: number;
  nextTier: string;
  pointsToNext: number;
  benefits: string[];
}

interface LoyaltyProgramProps {
  tier: LoyaltyTier;
}

export default function LoyaltyProgram({ tier }: LoyaltyProgramProps) {
  const [showBenefits, setShowBenefits] = useState(false);

  const progress = (tier.points / (tier.points + tier.pointsToNext)) * 100;

  return (
    <div className="bg-gradient-to-br from-accent/10 via-card to-card rounded-xl shadow-brand p-6 border border-accent/20">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
            <Icon name="StarIcon" size={24} className="text-accent-foreground" />
          </div>
          <div>
            <h3 className="font-heading font-semibold text-lg text-foreground">
              {tier.name} Member
            </h3>
            <p className="text-sm text-muted-foreground">
              {tier.points.toLocaleString()} points earned
            </p>
          </div>
        </div>
        <button
          onClick={() => setShowBenefits(!showBenefits)}
          className="text-sm font-medium text-accent hover:text-[#C49563] transition-colors duration-300"
        >
          {showBenefits ? 'Hide' : 'View'} Benefits
        </button>
      </div>

      <div className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <p className="text-sm font-medium text-foreground">
            Progress to {tier.nextTier}
          </p>
          <p className="text-sm font-semibold text-accent">
            {tier.pointsToNext.toLocaleString()} points needed
          </p>
        </div>
        <div className="w-full h-3 bg-surface rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-accent to-[#E5B887] transition-all duration-500"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      {showBenefits && (
        <div className="space-y-2 pt-4 border-t border-border">
          {tier.benefits.map((benefit, index) => (
            <div key={index} className="flex items-start space-x-2">
              <Icon name="CheckCircleIcon" size={16} className="text-accent mt-0.5 flex-shrink-0" />
              <p className="text-sm text-foreground">{benefit}</p>
            </div>
          ))}
        </div>
      )}

      <button className="w-full mt-6 px-6 py-3 bg-accent text-accent-foreground font-heading font-semibold rounded-lg hover:bg-[#C49563] transition-colors duration-300">
        Explore Rewards Catalog
      </button>
    </div>
  );
}